import { SmartMTEditorPopup } from "./_editor_popup";
import { getBlobUrl, getImgBlob, setImgBlob, setCurrentMode, showToastMessage, getCurrentMimeType } from "./_utils";
import { updateSaveButtons } from "./_editor_popup";
var $ = jQuery;

export const Rotate = (attachment) => {
    let currentRotation = 0;
    let flipX = 1;
    let flipY = 1;
    let isRotating = false;

    $('#smart-mt-rotate').on('click', function () {
        setCurrentMode('rotate');
        let imgBlob = getImgBlob();
        let url = getBlobUrl(imgBlob) !== false ? getBlobUrl(imgBlob) : attachment.url;
        let rotateContent = `
                <div class="smart-mt-content smart-mt-content-rotate">
                    <img id="smartmt-edit-image" src="${url}" alt="${attachment.name}" />
                </div>`;

        let rotateSidebar = `
                <div id="rotate-controls" class="sidebareffects">
                    <button class="button" id="rotate-right">
                        <span class="dashicons dashicons-image-rotate-right"></span> Rotate Right
                    </button>
                    <button class="button" id="rotate-left">
                        <span class="dashicons dashicons-image-rotate-left"></span> Rotate Left
                    </button>
                    <button class="button" id="flip-horizontal">
                        <span class="dashicons dashicons-image-flip-horizontal"></span> Flip Horizontal
                    </button>
                    <button class="button" id="flip-vertical">
                        <span class="dashicons dashicons-image-flip-vertical"></span> Flip Vertical
                    </button>
                </div>`;

        SmartMTEditorPopup(rotateContent, rotateSidebar);

        initRotateControls();
    });

    function initRotateControls() {
        const imageElement = document.getElementById("smartmt-edit-image");
        $(document).off("click", "#rotate-left");
        $(document).off("click", "#rotate-right");
        $(document).off("click", "#flip-horizontal");
        $(document).off("click", "#flip-vertical");

        $(document).on("click", "#rotate-left", function () {
            if (isRotating) { return; }
            currentRotation -= 90;
            rotateImage(imageElement);
        });

        $(document).on("click", "#rotate-right", function () {
            if (isRotating) { return; }
            currentRotation += 90;
            rotateImage(imageElement);
        });

        $(document).on("click", "#flip-horizontal", function () {
            if (isRotating) { return; }
            flipX *= -1;
            rotateImage(imageElement);
        });

        $(document).on("click", "#flip-vertical", function () {
            if (isRotating) { return; }
            flipY *= -1;
            rotateImage(imageElement);
        });
    }

    function rotateImage(imageElement) {
        if (!imageElement) {
            console.error("Image element not found.");
            return;
        }
        isRotating = true;

        imageElement.style.transition = "opacity 0.3s ease-out";
        imageElement.style.opacity = "0";
        const frozenWidth = imageElement.offsetWidth;
        const frozenHeight = imageElement.offsetHeight;
        imageElement.style.width = frozenWidth + "px";
        imageElement.style.height = frozenHeight + "px";

        setTimeout(() => {
            const transform = `rotate(${currentRotation}deg) scale(${flipX}, ${flipY})`;
            imageElement.style.transform = transform.trim();

            imageElement.style.transition = "opacity 0.3s ease-in, transform 0.3s ease-in-out";
            imageElement.style.opacity = "1";
            applyRotation(imageElement);
        }, 300);
    }

    function applyRotation(imageElement) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const imgWidth = imageElement.naturalWidth;
        const imgHeight = imageElement.naturalHeight;

        if (Math.abs(currentRotation) % 180 === 90) {
            canvas.width = imgHeight;
            canvas.height = imgWidth;
        } else {
            canvas.width = imgWidth;
            canvas.height = imgHeight;
        }

        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.translate(canvas.width / 2, canvas.height / 2);

        ctx.rotate((currentRotation * Math.PI) / 180);
        ctx.scale(flipX, flipY);

        ctx.drawImage(
            imageElement,
            -imgWidth / 2,
            -imgHeight / 2,
            imgWidth,
            imgHeight
        );

        canvas.toBlob((blob) => {
            if (blob) {
                const rotatedImageURL = URL.createObjectURL(blob);

                setImgBlob(blob);

                imageElement.src = rotatedImageURL;

                imageElement.onload = function () {
                    currentRotation = 0;
                    flipX = 1;
                    flipY = 1;

                    imageElement.style.transform = "";
                    imageElement.style.width = "";
                    imageElement.style.height = "";
                    imageElement.style.transition = "opacity 0.3s ease-in";
                    imageElement.style.opacity = "1";
                    isRotating = false;
                };
            } else {
                showToastMessage("Error: Unable to apply rotation.", "error");
                isRotating = false;
            }
        }, getCurrentMimeType());
    }
};
